import ClickoutWrapper from './ClickoutWrapper'

export default ClickoutWrapper
